import React from 'react';
var AsyncTeamOption = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/user-picker/team-option" */'./main').then(function (module) {
    return {
      default: module.TeamOption
    };
  });
});
export default AsyncTeamOption;